import React from 'react';
import { useSelector } from 'react-redux';

import HorizontalSlider from 'dpl/components/HorizontalSlider';

export default function FigoFeaturesSlider() {
  const features = useSelector(({ server }) => server.figo_features);

  return (
    <HorizontalSlider
      className="FigoFeaturesSlider"
      containerClassName="FigoFeaturesSlider__container"
      iconClassName="f3 bg-white o-80 br-100 box-shadow-strong b black pv2 ph2"
    >
      {features.map(({ title, description, color }) => (
        <div key={title} className="figo-feature__item">
          <div className={`figo-feature card card--${color}`}>
            <h3 className="figo-feature__title">{title}</h3>
            <p className="figo-feature__description">{description}</p>
          </div>
        </div>
      ))}
    </HorizontalSlider>
  );
}
